/**
 * WARNING: this is all DEPRECATED as it is for the old impact hub.
 */


import React from 'react';
import { Alert, Col, Row } from 'reactstrap';

import KStatus from '../base/data/KStatus';
import C from '../C';
import DataStore from '../base/plumbing/DataStore';
import Money from '../base/data/Money';
import Impact from '../base/data/Impact';
import ImpactDebit from '../base/data/ImpactDebit';
import List from '../base/data/List';
import SearchQuery from '../base/searchquery';
import { getPortalLink } from '../base/components/PortalLink';
import { assert } from '../base/utils/assert';
import { publish } from '../base/plumbing/Crud';

import PropControl from '../base/components/PropControl';
import PropControlDataItemList from '../base/components/propcontrols/PropControlDataItemList';
import { Card as CardCollapse } from '../base/components/CardAccordion';
import SubCard from '../base/components/SubCard';
import ListLoad from '../base/components/ListLoad';
import DataItemBadge from '../base/components/DataItemBadge';
import ImpactHubWiderImpactControls from './ImpactHubWiderImpactControls';
import ImpactHubFilterButtonControls from './ImpactHubFilterButtonControls';
import Misc from './MiscOverrides';

// We are using the deprecated functions here
import Campaign from '../base/data/DeprecatedImpactHubData';


function DeprecatedIHControls({ campaign, campaignPath }) {
	return <CardCollapse uncontrolled collapse warning title="DEPRECATED Old Impact Hub controls">
		<PropControl label="Ongoing Tense" path={campaignPath} prop="ongoing" type="checkbox"
			// deprecated
			help="(Deprecated - use end date) Is the campaign not yet started or ongoing (and should use -ing words)? Or finished (and should use the past tense)?"
		/>
		<ImpactControls campaign={campaign} campaignPath={campaignPath}/>
		<TotalViewsControls campaign={campaign} campaignPath={campaignPath} status={KStatus.DRAFT} />
		<ImpactHubFilterButtonControls campaign={campaign} campaignPath={campaignPath} />
		<ImpactHubWiderImpactControls campaignPath={campaignPath} />
		<DonationTotalControls campaign={campaign} campaignPath={campaignPath} />
	</CardCollapse>;
}


/**
 * @param {Object} p
 * @param {Campaign} p.campaign
 * @returns 
 */
function ImpactControls({ campaign }) {
	let pvSubs = Campaign.pvSubCampaigns({ campaign });
	let subs = pvSubs.value && List.hits(pvSubs.value).filter(sub => sub.id !== campaign.id);

	// TODO show if a list differs from published
	
	const templatePath = ['widget', 'newimpact'];
	const newTemplate = ({data}) => {
		assert(data.impact.name);
		const type = C.TYPES.ImpactDebit;
		const item = new ImpactDebit(data);
		item.id = `${data.impact.name}4${campaign.id}`;
		item.campaign = campaign.id;
		item.agencyId = campaign.agencyId;
		item.vertiser = campaign.vertiser;
		item.impact.dynamic = true;
		item.impact.input = 'impressions'; // default
		
		publish({ type, item, id: item.id });
		DataStore.invalidateList(type);
	};

	const canCreateID = Campaign.isMaster(campaign) || (campaign.id === Campaign.TOTAL_IMPACT);

	return <div>
		<Alert color="warning" size="sm">Showing draft lists - this may not match published lists.</Alert>

		{canCreateID && <SubCard title="Create Dynamic ImpactDebit Template">
			<PropControl path={[...templatePath, 'impact']} prop="name" type="select" options={Impact.KImpactNames} />
			<Misc.SubmitButton path={templatePath} onClick={newTemplate}>Create</Misc.SubmitButton>
		</SubCard>}

		<h4 className="mt-1">ImpactDebits for this Campaign</h4>
		<p>ImpactDebits are made automatically: closed-won Deals create Donation rows in monday.com, which get pulled through to here.</p>
		<PropControlDataItemList itemType={C.TYPES.ImpactDebit} canCreate={false} linkProp="campaign" linkValue={campaign.id} />

		<Row>
			<Col><h4>Sub Campaigns</h4></Col>
			<Col><h4>ImpactDebits</h4></Col>
		</Row>
		{pvSubs.resolved ? (
			subs.map(sub => <ImpactControlsSub key={sub.id} sub={sub} />)
		) : (
			<Misc.Loading />
		)}
	</div>;
}


function ImpactControlsSub({ sub }) {
	const q = SearchQuery.setProp(null, 'campaign', sub.id).query;

  return <Row>
		<Col><DataItemBadge item={sub} href={`${getPortalLink(sub)}?tab=Impact`} /></Col>
		<Col>
			<ListLoad type="ImpactDebit" status={KStatus.DRAFT} q={q} hideTotal navpage="impactdebit" ListItem={DataItemBadge} />
		</Col>
	</Row>;
}


/**
 * Controls for the donation total
 */
function DonationTotalControls({ campaign, campaignPath }) {
	const donationTotal = Campaign.dntn(campaign, !Campaign.isMaster(campaign)) || new Money(0);

	return (
		<SubCard>
			<PropControl type="Money" label="Total Donation Value" path={campaignPath} prop="dntn" changeCurrency
				help="(Optional) Set a static total donation amount. If left empty or 0, the amount is dynamically fetched based on live numbers."
			/>
			<p><i>What impact hub will show: {Money.str(donationTotal)}</i></p>
			<Alert color="warning" size="sm"><small>
				Impact Hub: Evolved (coming in March) will use a different system.</small></Alert>
		</SubCard>
	);
}


function TotalViewsControls({ campaign, campaignPath, status }) {
	const viewcount = Campaign.viewcount({ campaign, status });

	return <SubCard>
		<PropControl label="Total Unique People" path={campaignPath}
			prop="numPeople" type="number"
			help="(Optional) Set a static total number of (unique) viewers. If left empty, the amount is dynamically fetched based on live numbers."
		/>
		<i>What impact hub will show: {viewcount}</i>
	</SubCard>;
}


export default DeprecatedIHControls;
